import {
  BaseMaskCreateAndDeployResponse,
  CloudAccountApiListAbacAccountsRequest,
  DataAccessGroupInfo,
  DataGroupApiGetDataAccessGroupsRequest,
  DataGroupApiGetIdentitiesUsingDataRoleRequest,
  DataGroupApiListDataGroupsRequest,
  IdentityInfo,
  MultiBlockPolicyPreviewResponse,
  PageCloudAccountResponse,
  PageDataGroupListResponse,
  PagePolicyResponse,
  PolicyApiCreateAndDeployBaseMaskPoliciesRequest,
  PolicyApiCreateAndDeployMultiBlockPolicyRequest,
  PolicyApiDeletePolicyRequest,
  PolicyApiGetMultiBlockPolicyRequest,
  PolicyApiGetPolicyRequest,
  PolicyApiListPoliciesRequest,
  PolicyApiPreviewMultiBlockPolicyDdlRequest,
  PolicyApiUpdateAndDeployMultiBlockPolicyRequest,
  PolicyResponse,
  ResourceApiGetProviderStructureRequest,
  ResourceApiListSnowflakeTagsRequest,
  TagsResponse,
} from '@ariksa/abac/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeEveryAction } from 'services/utils/takeEveryAction';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { Abac } from 'api/index';

import { actions } from './slice';

export function* maskingPoliciesSaga() {
  yield takeLatestAction(actions.getCloudAccounts, doGetCloudAccounts);
  yield takeLatestAction(actions.getDataGroups, doGetDataGroups);
  yield takeEveryAction(actions.getDataGroupRoles, doGetDataGroupRoles);
  yield takeLatestAction(
    actions.createAndDeployBaseMaskPolicies,
    doCreateAndDeployBaseMaskPolicies,
  );
  yield takeLatestAction(actions.getDataPolicies, doGetDataPolicies);
  yield takeLatestAction(actions.createPolicy, doCreatePolicy);
  yield takeLatestAction(actions.deletePolicy, doDeletePolicy);
  yield takeLatestAction(actions.getPolicyById, doGetPolicyById);
  yield takeLatestAction(actions.getMultiBlockPolicy, doGetMultiBlockPolicy);
  yield takeLatestAction(
    actions.updateAndDeployMultiBlockPolicy,
    doUpdateAndDeployMultiBlockPolicy,
  );
  yield takeLatestAction(actions.getStructure, doGetProviderStructure);
  yield takeLatestAction(actions.getTagKeyValues, doGetTagKeyValues);
  yield takeLatestAction(actions.generatePolicy, doGeneratePolicy);
  yield takeLatestAction(
    actions.getIdentitiesUsingDataRole,
    doGetIdentitiesUsingDataRole,
  );
}

function* doGetCloudAccounts(
  ctx: QueryContext<
    PageCloudAccountResponse,
    CloudAccountApiListAbacAccountsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.CloudAccounts.listAbacAccounts(ctx.params));
}

function* doCreateAndDeployBaseMaskPolicies(
  ctx: QueryContext<
    BaseMaskCreateAndDeployResponse,
    PolicyApiCreateAndDeployBaseMaskPoliciesRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.createAndDeployBaseMaskPolicies(ctx.params),
  );
}

function* doGetPolicyById(
  ctx: QueryContext<PolicyResponse, PolicyApiGetPolicyRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.getPolicy(ctx.params));
}

function* doGetMultiBlockPolicy(
  ctx: QueryContext<any, PolicyApiGetMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.getMultiBlockPolicy(ctx.params));
}

function* doDeletePolicy(ctx: QueryContext<any, PolicyApiDeletePolicyRequest>) {
  yield call(ctx.fetch, () => Abac.Policy.deletePolicy(ctx.params));
}

function* doUpdateAndDeployMultiBlockPolicy(
  ctx: QueryContext<any, PolicyApiUpdateAndDeployMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.updateAndDeployMultiBlockPolicy(ctx.params),
  );
}

function* doGetDataPolicies(
  ctx: QueryContext<PagePolicyResponse, PolicyApiListPoliciesRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.listPolicies(ctx.params));
}

export function* doCreatePolicy(
  ctx: QueryContext<any, PolicyApiCreateAndDeployMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.createAndDeployMultiBlockPolicy(ctx.params),
  );
}

export function* doGetProviderStructure(
  ctx: QueryContext<
    Record<string, any>,
    ResourceApiGetProviderStructureRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.Resources.getProviderStructure(ctx.params));
}

export function* doGetTagKeyValues(
  ctx: QueryContext<TagsResponse, ResourceApiListSnowflakeTagsRequest>,
) {
  yield call(ctx.fetch, () => Abac.Resources.listSnowflakeTags(ctx.params));
}

export function* doGeneratePolicy(
  ctx: QueryContext<
    MultiBlockPolicyPreviewResponse,
    PolicyApiPreviewMultiBlockPolicyDdlRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.previewMultiBlockPolicyDdl(ctx.params),
  );
}

export function* doGetIdentitiesUsingDataRole(
  ctx: QueryContext<
    IdentityInfo[],
    DataGroupApiGetIdentitiesUsingDataRoleRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.DataGroup.getIdentitiesUsingDataRole(ctx.params),
  );
}

export function* doGetDataGroups(
  ctx: QueryContext<
    PageDataGroupListResponse,
    DataGroupApiListDataGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.listDataGroups(ctx.params));
}

export function* doGetDataGroupRoles(
  ctx: QueryContext<
    DataAccessGroupInfo[],
    DataGroupApiGetDataAccessGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getDataAccessGroups(ctx.params));
}
